








import { Component, Prop, Vue } from "vue-property-decorator";
import CarModel from "./CarForm/CarModel.vue";
import CarSignYear from "./CarForm/CarSignYear.vue";
import CarSerial from "./CarForm/CarSerial.vue";
import CarDocument from "./CarForm/CarDocument.vue";
import { Car, InsuranceCard } from "@/services/index.defs";
@Component({
    components: { CarModel, CarSignYear, CarSerial, CarDocument },
})
export default class CarForm extends Vue {
    @Prop() card: InsuranceCard;
    @Prop() car: Car;
}
